import "./ProjectInvitationBanner.css";

import { Column, InformationBox, Row } from "../../../../widget";
import { useProjectInvitationBanner } from "./useProjectInvitationBanner";

export const ProjectInvitationBanner = (): JSX.Element | null => {
  const { invitationType, navigateToProjectInvitations, corners } = useProjectInvitationBanner();

  if (!invitationType) return null;

  return (
    <Row spacingV="l">
      <Column span={12}>
        <InformationBox variant="info" corners={corners}>
          <div className="ProjectInvitationBanner">
            <p className="body2">
              You have received a project access {invitationType}, please view your organisation&apos;s {invitationType}
              s to accept or decline.
            </p>
            <button className="BtnLink" onClick={navigateToProjectInvitations}>
              View {invitationType}s
            </button>
          </div>
        </InformationBox>
      </Column>
    </Row>
  );
};
